import axios from 'axios';

let api_key='AIzaSyCuRE01JH7csgIrywq-YD94C6P8EEz8BC4';

  export function search(queries, response_function){
    let single_requests=[];
    for(let q of queries){query(q)}

    function query(q, next_page=null){
        let url='https://maps.googleapis.com/maps/api/place/textsearch/json?query='+q+'&key='+api_key;
        if(next_page!=null){url='https://maps.googleapis.com/maps/api/place/textsearch/json?pagetoken='+next_page+'&key'+api_key;}

        axios.get(url).then((response)=>{
          for(let x of response.results){single_requests.push(axios.get('https://maps.googleapis.com/maps/api/place/details/json?place_id='+x.place_id+'&fields='+fields+'&key='+api_key));}
          query(q, response.next_page_token);
      });
    }

    axios.all(single_requests).then(axios.spread((...responses) =>{
      let search_reponse=[];
      for(let r of responses){
        search_response.push(compileInfo(r));
      }
      response_function(search_response);
    }));
  }
